// Backend data structure types for API integration

/**
 * Backend forecast request structure (what we send to the API)
 */
export interface BackendNewForecast {
  forecast_name: string;
  description: string;
  workspace_id: string; // UUID
  tags: string[];
  owner: string; // UUID
  forecast_data: string; // JSON string
}

/**
 * Backend forecast update structure
 */
export interface BackendUpdateForecast {
  forecast_id: string; // UUID
  forecast_name?: string;
  description?: string;
  workspace_id?: string; // UUID
  tags?: string[];
  owner?: string; // UUID
  forecast_data?: string; // JSON string
  updated_by: string; // UUID
}

/**
 * Backend forecast response structure
 */
export interface BackendForecast {
  forecast_id: string; // UUID
  forecast_name: string;
  description: string;
  associated_workspace_id?: string; // UUID
  workspace_id?: string; // UUID (alternative field name)
  tags: string[];
  owner: string; // UUID
  forecast_data: string | object; // Can be JSON string or parsed object
  created_at: string; // ISO date
  updated_at: string; // ISO date
  forecast_created_at?: string; // Alternative field name
  forecast_updated_at?: string; // Alternative field name
  version?: number;
}

/**
 * Backend forecast list response structure
 */
export interface BackendForecastListResponse {
  forecasts: BackendForecast[];
  total_count?: number;
  total?: number; // Alternative field name
  total_pages?: number;
  page?: number;
  size?: number;
  has_more?: boolean;
}

/**
 * Helper to ensure required properties exist
 */
export function ensureBackendForecast(data: unknown): BackendForecast {
  const forecast = data as Partial<BackendForecast>;

  return {
    forecast_id: forecast.forecast_id || '',
    forecast_name: forecast.forecast_name || '',
    description: forecast.description || '',
    tags: forecast.tags || [],
    owner: forecast.owner || '',
    forecast_data: forecast.forecast_data || '{}',
    created_at: forecast.created_at || new Date().toISOString(),
    updated_at: forecast.updated_at || new Date().toISOString(),
    associated_workspace_id: forecast.associated_workspace_id,
    workspace_id: forecast.workspace_id,
    forecast_created_at: forecast.forecast_created_at,
    forecast_updated_at: forecast.forecast_updated_at,
    version: forecast.version
  };
}